import { ConfigClientModule } from '../models/ConfigClientModule'
import { UpdateConfigClientModule } from '../models/UpdateConfigClientModule'
import { ConfigClientModuleRepository } from '../repositories/ConfigClientModuleRepository'

export function ConfigRemedyModuleCase(
  configClientRepository: ConfigClientModuleRepository
) {
  return {
    async remedyConfig(patientId: string): Promise<ConfigClientModule> {
      return await configClientRepository.remedyConfig(patientId)
    },
    async updateRemedyConfig(
      config: UpdateConfigClientModule
    ): Promise<ConfigClientModule> {
      return await configClientRepository.updateRemedyConfig(config)
    }
  }
}
